import useAuth from "@/hooks/useAuth";
import type { TyClient } from "@/hooks/useAuth/types";
import useFetch from "@/hooks/useFetch";
import useTranslation from "@/hooks/useTranslation";
import type { TyApiResponse } from "@/types";
import FileInput from "@/UI/inputs/FileInput";
import PhoneInput from "@/UI/inputs/PhoneInput";
import TextInput from "@/UI/inputs/TextInput";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles.css";

type TyLocationState = { phone: string } | undefined;

type TyCompleteDataResponse = TyApiResponse<{ client: TyClient; token: string }>;

export default function CompleteDataScreen() {
    const t = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as TyLocationState;
    const setAuth = useAuth((store) => store.setAuth);

    const [name, setName] = useState("");
    const [picture, setPicture] = useState<File | null>(null);

    const { data, loading, error, invoke } = useFetch<TyCompleteDataResponse>("auth/complete-data", { method: "POST" }, false);

    useEffect(() => {
        if (!state?.phone) navigate("/login", { replace: true });
    }, [state, navigate]);

    useEffect(() => {
        if (!data?.success) return;
        setAuth(data.data.token, data.data.client);
        navigate("/select-store");
    }, [data]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!state?.phone || !name) return;
        invoke({ data: { phone: state.phone, name, ...(picture ? { newPicture: picture } : {}) } });
    };

    return (
        <div className="complete-data">
            <form className="complete-data-card" onSubmit={handleSubmit}>
                <div className="complete-data-header">
                    <p className="complete-data-title">{t.completeData.title}</p>
                    <p className="complete-data-subtitle">{t.completeData.subtitle}</p>
                </div>

                <div className="complete-data-fields">
                    <FileInput value={picture} onChange={setPicture} label={t.completeData.pictureLabel} disabled={loading} />
                    <PhoneInput value={state?.phone} onChange={() => {}} readOnly />
                    <TextInput value={name} onChange={setName} placeholder={t.completeData.namePlaceholder} disabled={loading} />
                </div>

                {error && <p className="complete-data-error">{error}</p>}

                <button type="submit" className="complete-data-submit" disabled={!name || loading}>
                    {t.completeData.submitButton}
                </button>
            </form>
        </div>
    );
}
